<template>
    <v-container :class="{'pa-0' : $vuetify.breakpoint.xsOnly}">
        <v-layout row wrap>
            <v-flex mt-4 xs12 text-center>
                <div class="headline">
                    {{ $t('sheddingPage.title') }}
                </div>
                <div class="subheading my-4">
                    {{ $t('sheddingPage.content1') }}
                </div>
                <div class="subheading mt-4 mb-0">
                    {{ $t('sheddingPage.thanks') }}
                </div>
                <div class="subheading">
                    {{ $t('sheddingPage.team') }}
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

export default {
    name: 'shedding-page',
    data() {
        return {
            timer: null,
        };
    },
};
</script>
